import { Component, computed, input } from '@angular/core';
import { CheckCircleFilled } from '../../icons/check-circle-filled/check-circle-filled';

/** Live checklist of the backend password rules (ASP.NET Identity defaults). */
export const PASSWORD_MIN_LENGTH = 6;

@Component({
  standalone: true,
  selector: 'app-password-requirements',
  imports: [CheckCircleFilled],
  templateUrl: './password-requirements.html',
  styleUrl: './password-requirements.scss',
})
export class PasswordRequirements {
  password = input<string | null | undefined>('');

  protected readonly rules = computed(() => {
    const value = this.password() ?? '';
    return [
      { label: `Najmanje ${PASSWORD_MIN_LENGTH} karaktera`, met: value.length >= PASSWORD_MIN_LENGTH },
      { label: 'Veliko i malo slovo', met: /[A-Z]/.test(value) && /[a-z]/.test(value) },
      { label: 'Najmanje jedan broj', met: /\d/.test(value) },
      { label: 'Najmanje jedan specijalni karakter', met: /[^A-Za-z0-9]/.test(value) },
    ];
  });

  /** True when every rule is met. */
  readonly isValid = computed(() => this.rules().every((r) => r.met));
}
